import { createFileRoute } from "@tanstack/react-router"
import Zones from "@/app/settings/metric/zones/page"

export const Route = createFileRoute("/settings/metric/zones")({
  component: Zones,
})
